import SignProvider from "./models/SignProvider";
import Vocab from "./models/Vocab";
import { providers, vocabs } from "./services/api";

let cachedVocabs: Vocab[] = [];
let cachedSignProviders: SignProvider[] = [];

export async function fetchVocabsCached(): Promise<Vocab[]> {
    if (cachedVocabs && cachedVocabs.length > 0) {
        return cachedVocabs;
    }    
    cachedVocabs = await vocabs();
    return cachedVocabs;
}

export async function fetchSignProvidersCached(): Promise<SignProvider[]> {
    if (cachedSignProviders && cachedSignProviders.length > 0) {
        return cachedSignProviders;
    }    
    cachedSignProviders = await providers();
    return cachedSignProviders;
}

export function clearCache(): void {
    cachedVocabs = [];
    cachedSignProviders = [];
    console.log('Static data cache cleared.');
}
